import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/auth/AuthProvider';
import { RequireAuth } from '@/auth/RequireAuth';
import LoginScreen from '@/auth/LoginScreen';
import ConsentLinkPage from '@/screens/ConsentLinkPage';
import AppShell from '@/AppShell';
import './styles/theme.css';

// Field devices are on poor connections: keep data a little stale rather than refetch on every
// window focus, and never retry a permission error into a loop.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<LoginScreen />} path="/login" />
            {/*
              * OUTSIDE RequireAuth, and the only route in the application that is. The farmer at
              * the end of a text message has a phone and a link, not an account (owner,
              * 2026-09-25: "message also can be considered with link -- for text message only").
              * Everything it can reach is granted to `anon` and bounded by hand.
              */}
            <Route element={<ConsentLinkPage />} path="/consent/:token" />
            <Route element={<RequireAuth><AppShell /></RequireAuth>} path="*" />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
